/**
 * WizardProgress Component
 * Shared step progress indicator for wizards
 */

import React from 'react';
import { Check } from 'lucide-react';
import './WizardShared.scss';

interface WizardProgressProps {
  currentStep: number;
  totalSteps: number;
  stepLabels?: string[];
}

export const WizardProgress: React.FC<WizardProgressProps> = ({
  currentStep,
  totalSteps,
  stepLabels = []
}) => {
  return (
    <div className="wizard-progress">
      {Array.from({ length: totalSteps }, (_, i) => i + 1).map((step) => (
        <React.Fragment key={step}>
          <div className={`wizard-progress-step ${
            step < currentStep ? 'completed' : 
            step === currentStep ? 'active' : 'pending'
          }`}>
            <div className="step-circle">
              {step < currentStep ? <Check size={14} /> : step}
            </div>
            {stepLabels[step - 1] && (
              <span className="step-label">{stepLabels[step - 1]}</span>
            )}
          </div>
          {step < totalSteps && <div className={`step-connector ${step < currentStep ? 'completed' : ''}`} />}
        </React.Fragment>
      ))}
    </div>
  );
};

export default WizardProgress;
